<template>
    <div class="block block-bordered">
        <div class="block-header block-header-default">
          <h3 class="block-title">Merk levertijd</h3>
        </div>
        <div class="block-content p-0">
          <table class="table table-borderless table-striped table-hover">
            <thead>
              <tr>
                <th>Merk</th>
                <th>Levertijd (in weken)</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="brand_delivery_time in brand_delivery_times" :key="brand_delivery_time.id">
                <td>
                  <a>{{brand_delivery_time.brand}}</a>
                </td>
                <td>
                  <div class="row">
                    <input v-model="delivery_times[brand_delivery_time.id]" type="number" ref="input" class="form-control" style="width: 100px;">
                    <button type="submit" class="btn btn-success btn-noborder"  @click="updateBrandDeliveryTimeField(brand_delivery_time.id)">
                      <i class="fa fa-check"></i>
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
    </div>
</template>
<script>
import http from '../utils/http'

export default {
  data () {
    return {
      brand_delivery_times: null,
      delivery_times: []
    }
  },
  methods: {
    loadData () {
      http.get('/brand-delivery-times')
        .then((result) => {
          this.brand_delivery_times = result.data
          this.fillArrays()
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Deze bestelling konden we niet vinden. Probeer het opnieuw.', 'warning')
        })
    },
    updateBrandDeliveryTimeField (id) {
      const data = {
        'delivery_time': this.delivery_times[id]
      }

      http.patch(`/brand-delivery-times/${id}`, data)
        .then((result) => {
          this.$swal('Hoera 😊', `De commissie is succesvol bijgewerkt.`, 'success')
        })
        .catch(() => {
          this.$swal('Ehmm...', 'Er is iets misgegaan bij het bijwerken van deze commissie. Probeer het opnieuw.', 'warning')
        })
    },
    fillArrays () {
      this.brand_delivery_times.forEach(element => {
        this.delivery_times[element.id] = element.delivery_time
      })
    }
  },
  created () {
    this.loadData()
  }
}
</script>


// WEBPACK FOOTER //
// BrandDeliveryTimeTab.vue?9fa3d3ea